var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.actionsLoading)?_c('gl-loading-icon',{staticClass:"gl-px-3",attrs:{"size":"sm"}}):_c('list-actions',{attrs:{"actions":_vm.actions,"available-actions":_vm.project.availableActions}})
}
var staticRenderFns = []

export { render, staticRenderFns }